import { css } from '@/styled-system/css';

export const filterChipIconStyles = css.raw({
  color: 'Chip.icon.default',
  marginInlineEnd: 'Chip.gap.leading',
});
